import styled from 'styled-components';

const MODAL_PADDING = 32;
const SECTION_GAP = 32;
const TABLE_HEADER_GAP = 8;
const ROW_PADDING = 16;
const COLUMN_GAP = 8;

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  padding: 24px;
`;

export const ModalPanel = styled.div`
  width: 900px;
  max-width: 95vw;
  max-height: 90vh;
  border-radius: 20px;
  background: #fff;
  box-shadow: 0 0 32px 0 #00000033;
  padding: ${MODAL_PADDING}px;
  display: flex;
  flex-direction: column;
  gap: ${SECTION_GAP}px;
`;

export const ModalTitle = styled.h2`
  margin: 0;
  font-size: 28px;
  text-align: center;
  font-family: 'Montserrat SemiBold';
`;

export const TableBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1 1 auto;
  min-height: 0;
`;

export const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${TABLE_HEADER_GAP}px;
  flex: 1 1 auto;
  min-height: 0;
`;

export const TableWrapper = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #e8e9ec;
  border-radius: 14px;
`;

const tableGrid = ($hasStatus) => `
  display: grid;
  grid-template-columns: ${
    $hasStatus
      ? 'minmax(0, 1fr) 132px 168px 56px'
      : 'minmax(0, 1fr) minmax(0, 1fr) auto'
  };
  column-gap: ${COLUMN_GAP}px;
  align-items: center;
`;

export const HeaderRow = styled.div`
  ${({ $hasStatus }) => tableGrid($hasStatus)}
  padding: 0 ${ROW_PADDING}px;
  color: #797e86;
`;

export const HeaderButton = styled.button`
  border: none;
  background: transparent;
  color: inherit;
  font-size: 14px;
  font-family: 'Montserrat Medium';
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 0;
  cursor: pointer;
  justify-self: ${({ $align }) =>
    $align === 'right' ? 'end' : $align === 'center' ? 'center' : 'start'};
  justify-content: ${({ $align }) =>
    $align === 'right' ? 'flex-end' : $align === 'center' ? 'center' : 'flex-start'};
  text-align: ${({ $align }) =>
    $align === 'right' ? 'right' : $align === 'center' ? 'center' : 'left'};
`;

export const ItemRow = styled.div`
  ${({ $hasStatus }) => tableGrid($hasStatus)}
  padding: 8px ${ROW_PADDING}px;
  border-bottom: ${({ $last }) => ($last ? 'none' : '1px solid #f2f2f3')};
`;

export const CellTitle = styled.span`
  font-size: 14px;
  color: var(--grey-95, #0C0D0D);
`;

export const CellStatus = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 12px;
  border-radius: 8px;
  font-size: 14px;
  font-family: 'Montserrat Medium';
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  background: ${({ $signed }) => ($signed ? '#E6F7E6' : '#E6F4FF')};
  color: ${({ $signed }) => ($signed ? '#28A745' : '#0095FF')};
  border: 0.5px solid ${({ $signed }) => ($signed ? '#AEEABD' : '#99D5FF')};
`;

export const CellDate = styled.span`
  font-size: 14px;
  color: var(--grey-95, #0C0D0D);
  text-align: ${({ $hasStatus }) => ($hasStatus ? 'right' : 'left')};
`;

export const RowActions = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: ${COLUMN_GAP}px;
`;

export const MenuAnchor = styled.div`
  position: relative;
  display: inline-flex;
`;

export const IconButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  height: 20px;
  width: 20px;
  cursor: pointer;
`;

export const DotsButton = styled.button`
  border: none;
  background: transparent;
  padding: 0;
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2px;
  cursor: pointer;
  color: #797e86;
`;

export const Dot = styled.span`
  width: 3px;
  height: 3px;
  border-radius: 50%;
  background: currentColor;
`;

export const AddNewButton = styled.button`
  border: none;
  background: transparent;
  color: #0095ff;
  display: flex;
  width: 100%;
  align-items: center;
  gap: 8px;
  font-family: 'Montserrat SemiBold';
  font-size: 14px;
  line-height: 1;
  cursor: pointer;
  padding: 0;

  svg {
    display: block;
    flex-shrink: 0;
  }

  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
  }
`;

export const EmptyMessage = styled.p`
  color: #797e86;
  margin: 0;
  text-align: center;
`;

export const LoadingWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 120px;
  padding: 24px 0;
`;

export const ModalFooter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const CloseButton = styled.button`
  width: 160px;
  min-width: 160px;
  height: 35px;
  border: none;
  border-radius: 10px;
  background: var(--grey-5, #f2f2f3);
  color: #0095ff;
  font-family: 'Montserrat Medium', sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: normal;
  text-align: center;
  white-space: nowrap;
  cursor: pointer;
  padding: 8px 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  &:hover {
    background: var(--grey-10, #e4e5e7);
  }
`;
